import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { TOOLTIP_DELAY } from '@app/shared/data/values';

@Component({
    selector: 'app-selector-confirm-panel',
    templateUrl: './selector-confirm-panel.component.html',
    styleUrls: ['./selector-confirm-panel.component.scss'],
    standalone: false
})
export class SelectorConfirmPanelComponent implements OnInit, OnChanges {

  tooltipDelay = TOOLTIP_DELAY.DATA_TABLE;
  sidenavOpened: boolean = false;
  @Input('data') data!: { [key: string]: any }[];
  selectionData = new SelectionModel<{ [key: string]: any } | any>(true, []);
  @Input('viewKeys') viewKeys!: { title: string[], subtitle?: string[], subAlt?: string; };
  @Input('noSelectedDataNote') noSelectedDataNote!: string;
  @Output('toggleSelectedRows') toggleSelectedRows: EventEmitter<any> = new EventEmitter<any>();
  @Output('clearAll') clearAll: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      this.selectionData = new SelectionModel<{ [key: string]: any } | any>(true, this.data ? [...this.data] : []);
    }
  }

  ngOnInit(): void {
    // no initial operations required
  }

  clearAllRow() {
    this.selectionData.clear();
    this.toggleSelectedRows.emit(this.selectionData.selected);
    this.clearAll.emit();
  }

  openPanel() {
    this.sidenavOpened = true;
  }

  closePanel() {
    this.toggleSelectedRows.emit(this.selectionData.selected);
    this.sidenavOpened = false;
  }

  isSelectedItem(row: any): boolean {
      return !!this.selectionData.selected?.find(data => (data == row));
  }

  showTitleValue(value: { [key: string]: any }) {
    let titleValue = '';
    this.viewKeys.title.forEach(t => {
      titleValue = `${titleValue} ${value[t]}`;
    });
    return titleValue;
  }

  showSubtitleValue(value: { [key: string]: any }) {
    if (!this.viewKeys?.subtitle?.length) return null;

    let keyValue = '';
    this.viewKeys.subtitle.forEach(sub => {
      keyValue = `${keyValue} ${this.showNestedKeyValue(value, sub)}`;
    });

    return keyValue?.trim();
  }

  showNestedKeyValue(value: { [key: string]: any }, nestedKeys: string) {
    let splittedkeys = nestedKeys.split('.');
    let subKeyValue = value;

    splittedkeys.forEach(sKey => {
      subKeyValue = subKeyValue[sKey];
    });

    return subKeyValue;
  }

}
